import R from 'ramda'

const changedKeys = (a, b) => {
    const allKeys = R.union(R.keys(a), R.keys(b))
    return R.reduce(((acc, k) => {
        if (!R.eqProps(k, a, b)) {
            acc.push(k);
        }
        return acc;
    }), [], allKeys);
}

export { changedKeys };



/** WEBPACK FOOTER **
 ** ./src/Utils.js
 **/